import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-assist-wrapper',
  templateUrl: './assist-wrapper.component.html',
  styleUrls: ['./assist-wrapper.component.css']
})
export class AssistWrapperComponent implements OnInit {
  subMenu = 'driver';
  isInspectionDot = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    const state = this.router.getCurrentNavigation().extras.state;
    if (state && state.isMapper && Boolean(state.isMapper)) {
      this.onSelectSubMenu('mapper');
    }
  }

  ngOnInit() {
    const urlSegment = this.activatedRoute.snapshot.url[1].path;
    this.subMenu = urlSegment === 'driver' ? 'driver' : 'assist';
  }

  onSelectSubMenu(menu) {
    this.subMenu = menu;
    if (this.subMenu === 'driver') {
      this.isInspectionDot = false;
    }
  }

}
